import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";

@Component({
    selector: 'app-alert-dialog',
    imports: [CommonModule, MatDialogModule, MatFormFieldModule, MatButtonModule],
    templateUrl: './alert-dialog.component.html',
    styleUrl: './alert-dialog.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: string) {}
}
